import addInsuranceModal from './addInsuranceModal';

export default addInsuranceModal;
